import React, { useReducer } from "react";
import { DateRangeInput } from "@datepicker-react/styled";
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { IconRefresh } from "../../../svg";
import { CardOptions } from "../../../components/CardOptions";
import { DynamicRadio } from "../../../components/DynamicRadio";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { PaginationCustom } from "../../../components/PaginationCustom";
import { ButtonOutline } from "../../../components/ButtonOutline";
import { Footer } from "../../../components/Footer";
import { StyledRow } from "../../../styled-components/StyledRow.style";
import { StyledColumn } from "../../../styled-components/StyledColumn.style";

const initialState = {
    startDate: null,
    endDate: null,
    focusedInput: null,
};

const typeOptions = [
    { value: "civil", name: "tipo", label: "Civil" },
    { value: "eletrica", name: "tipo", label: "Elétrica" },
    { value: "mecanica", name: "tipo", label: "Mecânica" },
];

const advancedSearch = { name: "advancedSearch", label: "Pesquisa Avançada" };

const sinisters = [
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
    {
        id: "16L5401M",
        status: 72,
        title: "Chubb",
        subtitle: "Colombo",
        info: "Capotamento",
        type: "Médio porte",
        options: [],
    },
];

const ufOptions = [
    { id: "000011", name: "RO" },
    { id: "000012", name: "AC" },
    { id: "000013", name: "AM" },
    { id: "000014", name: "RR" },
    { id: "000015", name: "PA" },
    { id: "000016", name: "AP" },
];

function reducer(state, action) {
    switch (action.type) {
        case "focusChange":
            return { ...state, focusedInput: action.payload };
        case "dateChange":
            return action.payload;
        default:
            throw new Error();
    }
}

export const MinhasTarefas = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <section>
            <Header />
            <main className="d-flex">
                <Menu></Menu>
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h2>Minhas tarefas</h2>
                            <IconRefresh color={"#EE4B21"} />
                        </div>
                        <ButtonOutline
                            outlineColor={"#EE4B21"}
                            backgroundColor={"#EE4B21"}
                            color={"#FFF"}
                            text={"Nova Tarefa"}
                            maxWidth={"280px"}
                        />
                    </div>

                    <div className="card">
                        <StyledForm>
                            <div className="form-container">
                                <DynamicRadio options={typeOptions} />
                            </div>
                            <div className="form-container">
                                <ToggleSwitch config={advancedSearch} />
                            </div>
                        </StyledForm>

                        <StyledForm>
                            <div className="form-container position-relative">
                                <DynamicInput
                                    type={"text"}
                                    placeholder={"Digite um segurado"}
                                    label={"Segurado"}
                                    name={"segurado"}
                                />
                            </div>

                            <div className="form-container position-relative">
                                <DynamicInput
                                    type={"text"}
                                    placeholder={"Digite uma cidade"}
                                    label={"Cidade"}
                                    name={"cidade"}
                                />
                            </div>

                            <div className="form-container position-relative">
                                <DynamicSelect
                                    placeholder={"Digite uma sigla"}
                                    label={"Estado sigla UF"}
                                    name={"uf"}
                                    options={ufOptions}
                                    keyValue={"id"}
                                    keyLabel={"name"}
                                />
                            </div>

                            <div className="form-container position-relative">
                                <DateRangeInput
                                    onDatesChange={(data) =>
                                        dispatch({
                                            type: "dateChange",
                                            payload: data,
                                        })
                                    }
                                    onFocusChange={(focusedInput) =>
                                        dispatch({
                                            type: "focusChange",
                                            payload: focusedInput,
                                        })
                                    }
                                    startDate={state.startDate} // Date or null
                                    endDate={state.endDate} // Date or null
                                    focusedInput={state.focusedInput} // START_DATE, END_DATE or null
                                />
                            </div>
                        </StyledForm>

                        <StyledForm justifyContent={"end"}>
                            <div className="form-container position-relative">
                                <ButtonOutline
                                    outlineColor={"#EE4B21"}
                                    backgroundColor={"white"}
                                    color={"#EE4B21"}
                                    text={"Pesquisar"}
                                />
                            </div>
                        </StyledForm>

                        <StyledRow>
                            {sinisters.map((item, index) => {
                                return (
                                    <StyledColumn key={index} xs="12" sm="6" md="3">
                                        <CardOptions
                                            key={index}
                                            id={item.id}
                                            status={item.status}
                                            title={item.title}
                                            subtitle={item.subtitle}
                                            info={item.info}
                                            type={item.type}
                                        />
                                    </StyledColumn>
                                );
                            })}
                        </StyledRow>

                        {/* <div className="d-flex justify-content-between flex-wrap">
                            {sinisters.map((item, index) => <CardOptions key={index} id={item.id} status={item.status} title={item.title} subtitle={item.subtitle} info={item.info}
                            type={item.type} />)}
                        </div> */}

                        <PaginationCustom />
                    </div>
                </StyledDefaultPage>
            </main>

        </section>
    );
};
